import { render } from "./componentGrid.vue?vue&type=template&id=0ddb61e8"
import script from "./componentGrid.vue?vue&type=script&lang=js"
export * from "./componentGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__